export const SET_CONFIGURATIONS = 'SetConfigurations';
export const SET_HAS_CONFIGURATION_CHANGES = 'SetHasConfigurationChanges';
export const UPDATE_CONFIGURATION = 'UpdateConfiguration';
export const CLEAR_UPDATED_CONFIGURATIONS = 'ClearUpdatedConfigurations';
export const SET_CONFIGURATIONS_AFTER_UPDATE = 'SetConfigurationsAfterUpdate';
export const SET_CONFIG_NAMES = 'SetConfigNames';
export const SET_CATEGORIES_SUBCATEGORIES = 'SetCategoriesSubcategories';
export const SET_CHANGED_BY_NAMES = 'SetChangedByNames';
export const SET_HISTORY = 'SetHistory';
export const RESET_HISTORY = 'ResetHistory';
